<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { getDeviceType, windowResizeEvent, getClientWidth } from '@/utils/device.js';
export default {
  name: 'App',
  mounted() {
    windowResizeEvent(this.handelDeviceType)
  },
  methods: {
    handelDeviceType () {
      this.$store.commit('Client_Width', getClientWidth());
      const { isMobile } = getDeviceType();
      this.$store.commit('GET_IS_MOBILE', isMobile);
    }
  },
}
</script>

<style lang="scss">
@import '@/assets/css/animate.scss';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue